import React, { useEffect, lazy, Suspense } from "react";
import { useParams } from "react-router-dom";
import Protected from "../Protected";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import FallbackLoader from "../components/FallbackLoader";
import Login from "../pages/login/Login";
const Error = lazy(() => import("../pages/other-pages/Error"));
const LoadingScreen = lazy(() => import("../pages/other-pages/Loading_Screen"));
const PageNotFound = lazy(() => import("../pages/other-pages/Page404"));
const EPL = lazy(() => import("../pages/landing-page/LandingPage"));
const Details = lazy(() => import("../pages/details/Details"));
const DetailsVerify = lazy(() => import("../pages/details-verify/DetailsVerify"));
const IncomeVerification = lazy(() => import("../pages/income-verification/IncomeVerification"));
const LoanIPO = lazy(() => import("../pages/load-ipo/LoanIPO"));
const Selfie = lazy(() => import("../pages/selfie/Selfie"));
const VerifyDetails = lazy(() => import("../pages/additional-details/AdditionalDetails"));
const ReviewDetails = lazy(() => import("../pages/review/ReviewPage"));
const BankDetails = lazy(() => import("../pages/bank-details/BankDetails"));
const LoanAgreement = lazy(() => import("../pages/loan-agreement/LoanAgreement"));
const LoanSummary = lazy(() => import("../pages/loan-summary/LoanSummary"));
const Rejected = lazy(() => import("../pages/other-pages/Rejected"));
const ReferenceDetails = lazy(() => import("../pages/reference-details/ReferenceDetails"));
const Vkyc = lazy(() => import("../pages/vkyc/Vkyc"));
const Udyam = lazy(() => import("../pages/udyam/Udyam"));
const DocUpload = lazy(() => import("../pages/doc-upload/DocUpload"));
const Nstp = lazy(() => import("../pages/nstp/Nstp"));


const EplRoutes = () => {
	const { path } = useParams();
	useEffect(() => {
		// console.log("UPSELLROUTES")
	}, []);

	return (
		<>
			<Suspense fallback={<FallbackLoader />}>
				{path.trim() === "error" && <Error />}
				{path.trim() === "loading" && <LoadingScreen />}
				{path.trim() === "pageNotFound" && <PageNotFound />}
				{path.trim() === "index" && <EPL />}
				{path.trim() === "login" && <GoogleReCaptchaProvider reCaptchaKey="6LcVMEMpAAAAAGyFUspEvgqXUB06IVZ1vqSovoNu"> <Login /> </GoogleReCaptchaProvider>}
				{path.trim() === "details" && (
					<Protected>
						<Details />
					</Protected>
				)}
				{path.trim() === "detailsVerify" && (
					<Protected>
						<DetailsVerify />
					</Protected>
				)}
				{path.trim() === "income" && (
					<Protected>
						<IncomeVerification />
					</Protected>
				)}
				{path.trim() === "ipo" && (
					<Protected>
						<LoanIPO />
					</Protected>
				)}
				{path.trim() === "selfie" && (
					<Protected>
						<Selfie />
					</Protected>
				)}
				{path.trim() === "verifyDetails" && (
					<Protected>
						<VerifyDetails />
					</Protected>
				)}
				{path.trim() === "review" && (
					<Protected>
						<ReviewDetails />
					</Protected>
				)}
				{path.trim() === "bankDetails" && (
					<Protected>
						<BankDetails />
					</Protected>
				)}
				{path.trim() === "agreement" && (
					<Protected>
						<LoanAgreement />
					</Protected>
				)}
				{path.trim() === "offer" && (
					<Protected>
						<LoanSummary />
					</Protected>
				)}
				{path.trim() === "rejected" && (
					<Protected>
						<Rejected />
					</Protected>
				)}
				{path.trim() === "reference" && (
					<Protected>
						<ReferenceDetails />
					</Protected>
				)}
				{path.trim() === "verificationPending" && (
					<Protected>
						<Vkyc />
					</Protected>
				)}
				{path.trim() === ("udyam") && (
					<Protected>
						<Udyam />
					</Protected>
				)}
				{path.trim() === ("docUpload") && (
					<Protected>
						<DocUpload />
					</Protected>
				)}
				{path.trim() === ("nstp") && (
					<Protected>
						<Nstp />
					</Protected>
				)}
			</Suspense>
		</>
	);
};

export default EplRoutes;
